<template>
  <Header />
  <main>
    <Hero />
    <About />
    <Experience />
    <Education />
    <Skills />
    <Projects />
    <Talks />
    <Contact />
  </main>
  <Footer />
</template>

<script setup lang="ts">
import mixpanel from 'mixpanel-browser/src/loaders/loader-module-core';

import Footer from '@/components/app/Footer.vue';
import Header from '@/components/app/Header.vue';

import About from '@/components/section/About.vue';
import Contact from '@/components/section/Contact.vue';
import Education from '@/components/section/Education.vue';
import Experience from '@/components/section/Experience.vue';
import Hero from '@/components/section/Hero.vue';
import Projects from '@/components/section/Projects.vue';
import Skills from '@/components/section/Skills.vue';
import Talks from '@/components/section/Talks.vue';

mixpanel.track('View');
</script>

<style lang="scss">
html * {
  box-sizing: border-box;
}

body {
  --theme: light dark;

  background-color: var(--color-background);
  color: var(--color-text);
  color-scheme: var(--theme);
  font-family: var(--font-family);
  font-weight: 200;
  line-height: 1.5;
}

html, body {
  scroll-behavior: smooth;
}
</style>
